import {
  DraftDocumentsState,
  INITIAL_DRAFT_COUNTER_STATE,
} from '@store/documents/outgoing/draft.state';

import {
  FetchTotalDraftFailureAction,
  FetchTotalDraftSuccessAction,
  IncrementTotalDraftAction,
  IncrementTotalReadyToSendAction,
} from '../../documents.actions';

export function fetchDraftCounterSuccess<T extends DraftDocumentsState>(
  state: T,
  action: FetchTotalDraftSuccessAction,
): T {
  return {
    ...state,
    dashboardView: {
      ...state.dashboardView,
      totalDraft: {
        ...state.dashboardView.totalDraft,
        total: action.payload.total,
        identities: action.payload.identities,
        lastFetchedAt: Date.now(),
      },
    },
  };
}

export function incrementDraftCounter<T extends DraftDocumentsState>(
  state: T,
  action: IncrementTotalReadyToSendAction,
): T {
  return {
    ...state,
    dashboardView: {
      ...state.dashboardView,
      totalDraft: {
        ...state.dashboardView.totalDraft,
        total: Math.max(0, state.dashboardView.totalDraft.total + action.payload.count),
        identities: action.payload.identity
          ? {
              ...state.dashboardView.totalDraft.identities,
              // `?? 0`: identities starts empty and fetchDraftCounterFailure empties it again, so
              // a bucket the server has not named yet would otherwise go to NaN on the first move.
              [action.payload.identity]: Math.max(
                0,
                (state.dashboardView.totalDraft.identities[action.payload.identity] ?? 0) +
                  action.payload.count,
              ),
            }
          : { ...state.dashboardView.totalDraft.identities },
      },
    },
  };
}

export function decrementDraftCounter<T extends DraftDocumentsState>(
  state: T,
  action: IncrementTotalDraftAction,
): T {
  return {
    ...state,
    dashboardView: {
      ...state.dashboardView,
      totalDraft: {
        ...state.dashboardView.totalDraft,
        // Clamped at 0: attribution between an increment and its matching decrement can drift
        // (e.g. identity mismatch between the v1/v2 draft caches), and without a floor a stray
        // decrement renders as a literal "-1" badge instead of just staying hidden like 0 does.
        total: Math.max(0, state.dashboardView.totalDraft.total - action.payload.count),
        identities: action.payload.identity
          ? {
              ...state.dashboardView.totalDraft.identities,
              [action.payload.identity]: Math.max(
                0,
                (state.dashboardView.totalDraft.identities[action.payload.identity] ?? 0) -
                  action.payload.count,
              ),
            }
          : { ...state.dashboardView.totalDraft.identities },
      },
    },
  };
}

export function fetchDraftCounterFailure<T extends DraftDocumentsState>(
  state: T,
  _action: FetchTotalDraftFailureAction,
): T {
  return {
    ...state,
    dashboardView: {
      ...state.dashboardView,
      totalDraft: INITIAL_DRAFT_COUNTER_STATE,
    },
  };
}
